import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "water-probes";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const stripWaterProbeIds = (waterProbe = {}) => {
  const { id, id_doc, idDoc, createdAt, updatedAt, deletedAt, ...payload } = waterProbe;
  return payload;
};

const WaterProbesService = {
  findAll: async () =>
    apiService.get(ENDPOINT, {
      params: currentUserPayload(),
    }),

  findById: async (id) =>
    apiService.get(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      params: currentUserPayload(),
    }),

  create: async (waterProbe) =>
    apiService.post(ENDPOINT, {
      ...currentUserPayload(),
      ...stripWaterProbeIds(waterProbe),
    }),

  update: async (id, waterProbe) =>
    apiService.put(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      ...currentUserPayload(),
      ...stripWaterProbeIds(waterProbe),
    }),

  remove: async (id) =>
    apiService.delete(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      data: currentUserPayload(),
    }),
};

export default WaterProbesService;
